import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { intlShape, injectIntl, FormattedMessage } from 'react-intl';
import Grid from '../Grid';
import Input from '../Input';
import Form from '../Form';
import Popup from './Popup';
import SaveChangesButton from '../SaveChangeButtonPopup';
import s from './Popup.css';
import Messages from './Messages';
import cx from 'classnames';
import { saveDeviceData } from '../../actions/device';

class EditDevicePopup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      additionalinfo: this.props.comment,
      address: this.props.address,
    };
  }

  onClick = () => {
    this.props.saveDeviceData(this.props.serial, {
      additionalinfo: this.state.additionalinfo,
      address: this.state.address,
    });
    this.props.onClose();
  };

  onFieldChange = (field, e) => {
    this.setState({
      [field]: e,
    });
  };

  renderForm = (intl, messages, devicetype) => {
    const notFirmwareTypes = ['safe-t', 'safetech', 'safefloor'];
    if(notFirmwareTypes.indexOf(devicetype) < 0){
      return(
        <Form onSubmit={this.onSubmit}>
          <Grid.Cell>
            <Input
              type="text"
              name="address"
              title={intl.formatMessage(
                messages.address_label_main_screen_text,
              )}
              value={this.props.address}
              onChange={this.onFieldChange.bind(this, 'address')}
              titleVisibility
            />
          </Grid.Cell>
          <Grid.Cell>
            <Input 
              type="text"
              name="additionalinfo"
              title={intl.formatMessage(
                messages.additional_information_label_main_screen_text,
              )}
              value={this.props.comment}
              onChange={this.onFieldChange.bind(this, 'additionalinfo')}
              titleVisibility
            />
          </Grid.Cell>
          <SaveChangesButton devicetype={devicetype} onClick={this.onClick} />
        </Form>
      );
    }
    return(
      <Form onSubmit={this.onSubmit}>
        <Grid.Cell>
          <Input
            type="text"
            name="address"
            title={intl.formatMessage(
              messages.address_label_main_screen_text,
            )}
            value={this.props.address}
            onChange={this.onFieldChange.bind(this, 'address')}
            titleVisibility
          />
        </Grid.Cell>
        <SaveChangesButton devicetype={devicetype} onClick={this.onClick} />
      </Form>
    );
  }

  render() {
    const { intl, devicetype, serial } = this.props;
    const messages = Messages();
    const isSuperior = devicetype === 'superior';
    const notFirmwareTypes = ['safe-t', 'safetech', 'safefloor'];
    return (
      <Popup
        className={s.Popup__editdevice}
        onClose={this.props.onClose}
        devicetype={devicetype}
        overrideOnClose
      >
        {serial}
        {this.renderForm(intl, messages, devicetype)}
      </Popup>
    );
    
  }
}

EditDevicePopup.propTypes = {
  onClose: PropTypes.func.isRequired,
  saveDeviceData: PropTypes.func.isRequired,
  intl: intlShape.isRequired,
  serial: PropTypes.string.isRequired,
  comment: PropTypes.string,
  address: PropTypes.string,
  devicetype: PropTypes.string,
};

EditDevicePopup.defaultProps = {
  comment: '',
  address: '',
  devicetype: '',
};

const mapDispatch = dispatch => {
  return {
    saveDeviceData: (serial, data) => dispatch(saveDeviceData(serial, data)),
  };
};

export default injectIntl(
  compose(connect(null, mapDispatch), withStyles(s))
  (EditDevicePopup)
);



// WEBPACK FOOTER //
// ./src/components/Popup/EditDevicePopUp.js